import { FooterAdapter } from "./Footer";

export { FooterAdapter as Footer };
